import React, { useMemo } from 'react';

import FormInput from 'kingpin/forms/FormInput';
import Inputs from 'components/Inputs';

type RenderMode = 'auto' | 'table' | 'cards';

const RENDER_MODES: { key: RenderMode; label: string }[] = [
  { key: 'auto', label: 'Auto' },
  { key: 'table', label: 'Table' },
  { key: 'cards', label: 'Cards' },
];

/**
 * Picks how a sub-period fact table lays out: `auto` (table for ≤2 fields, else
 * stacked cards), or forcing `table` / `cards`. Undefined is treated as `auto`.
 */
const RenderModeInput = ({
  value,
  setValue,
}: {
  value: RenderMode | undefined;
  setValue: (value: RenderMode) => void;
}) => {
  const options = useMemo(
    (): DropdownOption[] =>
      RENDER_MODES.map((mode) => ({
        key: mode.key,
        label: mode.label,
        isSelected: (value ?? 'auto') === mode.key,
        onSelected: () => setValue(mode.key),
      })),
    [value, setValue],
  );

  return (
    <FormInput label={'Render mode'}>
      <Inputs.Dropdown options={options} />
    </FormInput>
  );
};

export default RenderModeInput;
